module.exports = __webpack_public_path__ + "static/media/arrow-left.ca609d95.svg";